/* パララックス */

let parallax = () => {
  gsap.utils.toArray('.js-parallax').forEach((el) => {
    const y = el.getAttribute('data-y') || -50;
    const start = el.getAttribute('data-start') || 'start bottom';

    // position: absolute の要素は親をトリガーにしないと位置計算がずれる
    const isAbsolute = getComputedStyle(el).position === 'absolute';
    const trigger = isAbsolute ? el.parentElement || el : el;

    gsap.to(el, {
      y: y,
      scrollTrigger: {
        trigger: trigger,
        start: start,
        end: 'bottom top',
        scrub: 1,
        // markers: true,
      },
    });
  });
};

/**
 * 初期化
 */
let init = () => {
  parallax();
};

export default { init, parallax };
